import { DomSanitizer } from '@angular/platform-browser';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { QuillModule, SelectionChange } from 'ngx-quill';
import { Constants } from '@app/core/services/constants';

@Component({
  selector: 'app-formly-field-html',
  templateUrl: './formly-field-html.component.html',
  styleUrls: ['./formly-field-html.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    // IonicModule,
    QuillModule,
  ],
})
export class FormlyFieldHtmlComponent extends FormlyFieldAnyComponent {
  // Quill editor configuration
  public quillConfig = Constants.desktopQuillConfig;
  public quillMobileConfig = Constants.mobileQuillConfig;
  private quillInstance: any = null;

  constructor(public domSanitizer: DomSanitizer,
              public changeDetectorRef: ChangeDetectorRef) { 
    super();
  }

  public getMaxContentLength(): number {
    return this.field.props?.maxLength || 5000;
  }

  // Quill editor event handlers
  // Get the appropriate Quill config based on screen size
  getQuillConfig() {
    // Check if we're on mobile (you can also use Ionic's Platform service)
    const isMobile = window.innerWidth < 768;
    return isMobile ? this.quillMobileConfig : this.quillConfig;
  }

  onSelectionChanged(selection: SelectionChange) {
    // Handle selection changes if needed
  }

  public onEditorCreated(quill: any) {
    this.quillInstance = quill;
  }

  public onContentChanged(content: any) {
    // Trigger onChange callbacks if defined
    this.onChange(content.html || '');
    this.changeDetectorRef.markForCheck();
  }

  // Get current Quill config based on screen size
  public getCurrentQuillConfig() {
    const isMobile = window.innerWidth < 768;
    return isMobile ? this.quillMobileConfig : this.quillConfig;
  }

  // Character counting for content
  public getCharacterCount(): number {
    if (this.quillInstance) {
      const text = this.quillInstance.getText();
      return text.trim().length;
    }
    return 0;
  }


}
